<template>
  <form>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label for="exampleInputEmail1" class="form-label">CONNECTION <span class="text-danger">*</span></label>
          <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="exampleInputPassword1" class="form-label">HOST <span class="text-danger">*</span></label>
          <input type="password" class="form-control" id="exampleInputPassword1" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="exampleInputEmail1" class="form-label">PORT <span class="text-danger">*</span></label>
          <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="exampleInputPassword1" class="form-label">DATABASE <span class="text-danger">*</span></label>
          <input type="password" class="form-control" id="exampleInputPassword1" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="exampleInputEmail1" class="form-label">USERNAME</label>
          <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label for="exampleInputPassword1" class="form-label">PASSWORD <span class="text-danger">*</span></label>
          <input type="password" class="form-control" id="exampleInputPassword1" />
        </div>
      </div>
    </div>
  </form>
</template>
